import React from 'react';
import styled, { css } from 'styled-components';
import { containerQuery } from '../styles';

// This component is used to apply container queries to the booking widget
// Current styled-components are not compatible with container queries, so we need to use a separate component to apply them.
// TODO: Upgrade styled-components to v6 to use container queries natively. (Introduced breaking changes)
const ContainerQueryStyles = ({ widgetId }: { widgetId: string }) => {
    return (
        <style
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
                __html: containerQuery(widgetId),
            }}
        />
    );
};

export const bodyCustomStyles = css`
    ${({ theme }) => theme.evaluateStyles({ styleKey: 'bookerBody' })}
`;
const subtitleCustomStyles = css`
    ${({ theme }) => theme.evaluateStyles({ styleKey: 'bookerSubtitle' })}
`;
export const titleCustomStyles = css`
    ${({ theme }) => theme.evaluateStyles({ styleKey: 'bookerTitle' })}
`;

export const ParagraphWrapper = styled.div.attrs({
    className: 'dmNewParagraph',
})`
    p {
        margin-block: 0;
        color: ${({ theme }) => theme.bookerPrimaryColor} !important;
        ${subtitleCustomStyles}
    }
`;

export const DudaParagraphWrapper = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    return (
        <ParagraphWrapper>
            <p>{children}</p>
        </ParagraphWrapper>
    );
};

export default ContainerQueryStyles;
